bovoApp.controller('ServiceHealthController', ['$scope', '$http', '$interval', '$filter',
function($scope, $http, $interval, $filter) {
    
    // Initialize variables
    $scope.services = [];
    $scope.summary = {};
    $scope.loading = true;
    $scope.lastRefresh = null;
    $scope.autoRefresh = true;
    $scope.refreshInterval = 30; // seconds
    $scope.filterText = '';
    $scope.selectedCriticality = '';
    $scope.selectedStatus = '';
    
    // Auto-refresh interval holder
    var refreshTimer = null;
    
    // Initialize controller
    $scope.init = function() {
        $scope.loadServiceHealth();
        $scope.startAutoRefresh();
    };
    
    // Load service health data
    $scope.loadServiceHealth = function() {
        $scope.loading = true;
        
        $http.get('/api/service-health-status').then(function(response) {
            if (response.data.success) {
                $scope.services = response.data.services;
                $scope.summary = response.data.summary;
                $scope.lastRefresh = new Date();
                
                // Sort services by criticality and status
                $scope.sortServices();
            } else {
                Messenger().error('Service durumları yüklenirken hata oluştu: ' + response.data.message);
            }
            $scope.loading = false;
        }).catch(function(error) {
            Messenger().error('Service durumları yüklenirken hata oluştu');
            $scope.loading = false;
            console.error('Service health error:', error);
        });
    };
    
    // Sort services by priority
    $scope.sortServices = function() {
        if (!$scope.services) return;
        
        $scope.services.sort(function(a, b) {
            // First by status priority (delayed > buffer_time > on_time > unknown)
            var statusPriority = {
                'delayed': 4,
                'buffer_time': 3,
                'on_time': 2,
                'unknown': 1
            };
            
            var statusDiff = statusPriority[b.status] - statusPriority[a.status];
            if (statusDiff !== 0) return statusDiff;
            
            // Then by criticality (high > medium > low)
            var criticalityPriority = {
                'high': 3,
                'medium': 2,
                'low': 1
            };
            
            var criticalityDiff = criticalityPriority[b.criticality] - criticalityPriority[a.criticality];
            if (criticalityDiff !== 0) return criticalityDiff;
            
            // Finally by service name
            return a.service_name.localeCompare(b.service_name);
        });
    };
    
    // Manual service trigger
    $scope.triggerService = function(service) {
        if (!confirm(`${service.service_name.toUpperCase()} servisi tetiklenecek. Onaylıyor musunuz?`)) {
            return;
        }
        
        service.triggering = true;
        
        $http.post('/api/trigger-service', {
            service_name: service.service_name,
            service_type: service.service_type
        }).then(function(response) {
            if (response.data.success) {
                Messenger().success(response.data.message);
                // Refresh data after 3 seconds to see updated status
                setTimeout(function() {
                    $scope.loadServiceHealth();
                }, 3000);
            } else {
                Messenger().error(response.data.message);
            }
            service.triggering = false;
        }).catch(function(error) {
            Messenger().error('Servis tetikleme sırasında hata oluştu');
            service.triggering = false;
            console.error('Trigger error:', error);
        });
    };
    
    // Get status class for badge styling
    $scope.getStatusClass = function(status) {
        switch(status) {
            case 'on_time': return 'label-success';
            case 'buffer_time': return 'label-warning'; 
            case 'delayed': return 'label-danger';
            case 'running': return 'label-info';
            default: return 'label-default';
        }
    };
    
    // Get status text in Turkish
    $scope.getStatusText = function(status) {
        switch(status) {
            case 'on_time': return 'Çalışıyor';
            case 'buffer_time': return 'Tampon Sürede';
            case 'delayed': return 'Gecikmede';
            case 'running': return 'Çalışıyor...';
            case 'failed': return 'Başarısız';
            default: return 'Bilinmiyor';
        }
    };
    
    // Get criticality class for badge styling
    $scope.getCriticalityClass = function(criticality) {
        switch(criticality) {
            case 'high': return 'label-danger';
            case 'medium': return 'label-warning';
            case 'low': return 'label-success';
            default: return 'label-default';
        }
    };
    
    // Get criticality text in Turkish
    $scope.getCriticalityText = function(criticality) {
        switch(criticality) {
            case 'high': return 'Yüksek';
            case 'medium': return 'Orta';
            case 'low': return 'Düşük';
            default: return 'Bilinmiyor';
        }
    };
    
    // Format service name for display
    $scope.formatServiceName = function(serviceName) {
        return serviceName.toUpperCase();
    };
    
    // Format service type for display
    $scope.formatServiceType = function(serviceType) {
        switch(serviceType) {
            case 'status_update': return 'Statü Update';
            case 'status_update_backup': return 'Statü Update (Backup)';
            case 'after_delivery_check': return 'Teslim Sonrası Kontrol';
            case 'return_status': return 'İade Statü';
            case 'tracking_number': return 'Tracking Number';
            case 'return_tracking_url': return 'İade Tracking URL';
            default: return serviceType;
        }
    };
    
    // Format date for display
    $scope.formatDate = function(dateString) {
        if (!dateString) return '--';
        
        var date = new Date(dateString);
        return $filter('date')(date, 'dd.MM.yyyy HH:mm');
    };
    
    // Get time since last check
    $scope.getTimeSince = function(dateString) {
        if (!dateString) return '--';
        
        var date = new Date(dateString);
        var now = new Date();
        var diffMinutes = Math.floor((now - date) / (1000 * 60));
        
        if (diffMinutes < 1) return 'Şimdi';
        if (diffMinutes < 60) return diffMinutes + ' dk önce';
        
        var diffHours = Math.floor(diffMinutes / 60);
        if (diffHours < 24) return diffHours + ' saat önce';
        
        var diffDays = Math.floor(diffHours / 24);
        return diffDays + ' gün önce';
    };
    
    // Filter services based on search criteria
    $scope.filteredServices = function() {
        if (!$scope.services) return [];
        
        var filtered = $scope.services;
        
        // Text filter
        if ($scope.filterText) {
            filtered = filtered.filter(function(service) {
                return service.service_name.toLowerCase().includes($scope.filterText.toLowerCase()) ||
                       service.command.toLowerCase().includes($scope.filterText.toLowerCase());
            });
        }
        
        // Criticality filter
        if ($scope.selectedCriticality) {
            filtered = filtered.filter(function(service) {
                return service.criticality === $scope.selectedCriticality;
            });
        }
        
        // Status filter
        if ($scope.selectedStatus) {
            filtered = filtered.filter(function(service) {
                return service.status === $scope.selectedStatus;
            });
        }
        
        return filtered;
    };
    
    // Clear all filters
    $scope.clearFilters = function() {
        $scope.filterText = '';
        $scope.selectedCriticality = '';
        $scope.selectedStatus = '';
    };
    
    // Start auto refresh
    $scope.startAutoRefresh = function() {
        if (refreshTimer) {
            $interval.cancel(refreshTimer);
        }
        
        if ($scope.autoRefresh) {
            refreshTimer = $interval(function() {
                if (!$scope.loading) {
                    $scope.loadServiceHealth();
                }
            }, $scope.refreshInterval * 1000);
        }
    };
    
    // Stop auto refresh
    $scope.stopAutoRefresh = function() {
        if (refreshTimer) {
            $interval.cancel(refreshTimer);
            refreshTimer = null;
        }
    };
    
    // Toggle auto refresh
    $scope.toggleAutoRefresh = function() {
        if ($scope.autoRefresh) {
            $scope.startAutoRefresh();
        } else {
            $scope.stopAutoRefresh();
        }
    };
    
    // Change refresh interval
    $scope.changeRefreshInterval = function(seconds) {
        $scope.refreshInterval = seconds;
        if ($scope.autoRefresh) {
            $scope.startAutoRefresh();
        }
    };
    
    // Get row class based on service status
    $scope.getRowClass = function(service) {
        switch(service.status) {
            case 'delayed': return 'danger';
            case 'buffer_time': return 'warning';
            case 'failed': return 'danger';
            case 'running': return 'info';
            default: return '';
        }
    };
    
    // Export services to CSV
    $scope.exportToCsv = function() {
        var csv = 'Service Name,Service Type,Command,Status,Criticality,Frequency,Last Checked,Delay Minutes\n';
        
        $scope.services.forEach(function(service) {
            csv += [
                service.service_name,
                service.service_type,
                service.command,
                service.status,
                service.criticality,
                service.frequency,
                service.last_checked || '',
                service.delay_minutes || 0
            ].join(',') + '\n';
        });
        
        var blob = new Blob([csv], { type: 'text/csv' });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = 'service-health-' + new Date().toISOString().split('T')[0] + '.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };
    
    // Cleanup on destroy
    $scope.$on('$destroy', function() {
        $scope.stopAutoRefresh();
    });
    
    // Initialize the controller
    $scope.init();
}]);